// libraries.
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// selectors.
import {
  getSelectedDocument,
  setSelectedDocument,
  getTabsDocumentsReview,
  TabsDocumentsReviewOption,
  getSelectedTask,
} from '@domains/documents-review/store/slices/document-review-slice';

// components.
import { FileViewer } from './components/FileViewer';
import { DocumentsList } from './components/DocumentsList';
import { ModalViewer } from './components/ModalViewer';

interface DocumentsViewerProps {
  nid?: string;
}

export const DocumentsViewer = ({ nid }: DocumentsViewerProps) => {
  const dispatch = useDispatch();

  const selectedDocument = useSelector(getSelectedDocument);
  const activeTab = useSelector(getTabsDocumentsReview);
  const selectedTask = useSelector(getSelectedTask);

  const resolvedNid = nid ?? selectedTask?.nid;

  const onSelectDocument = (fileUrl: string) => {
    dispatch(setSelectedDocument(fileUrl));
  };

  let content = null;
  if (selectedDocument) {
    content = <FileViewer fileUrl={selectedDocument} />;
  } else if (activeTab === TabsDocumentsReviewOption.DOCUMENTS) {
    content = <DocumentsList onSelectDocument={onSelectDocument} nid={resolvedNid} />;
  }

  return <div className="d-flex flex-column h-100">{content}</div>;
};

interface DocumentsModalViewerProps {
  nid?: string;
}

export const DocumentsModalViewer = ({ nid }: DocumentsModalViewerProps) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const handleSelectDocument = (fileUrl: string) => {
    dispatch(setSelectedDocument(fileUrl));
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    dispatch(setSelectedDocument(null));
  };

  return (
    <div>
      <DocumentsList nid={nid} onSelectDocument={handleSelectDocument} />
      <ModalViewer show={showModal} onClose={handleCloseModal} />
    </div>
  );
};
